import { AbstractControl, ValidationErrors } from "@angular/forms";
import moment from "moment";

export class TimeToNowValidator {
    static IsBefore(AC: AbstractControl): ValidationErrors | null {
        if (AC && AC.value && moment(AC.value, "HH:mm").isBefore()) {
            return { IsBefore: true };
        }
        return null;
    }

    static IsAfter(AC: AbstractControl): ValidationErrors | null {
        if (AC && AC.value && moment(AC.value, "HH:mm").isAfter()) {
            return { IsAfter: true };
        }
        return null;
    }
}
